
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdOption } from '@angular/material';

import { ValidationService } from './../../../shared/services/validation.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { LabTestDataService } from './lab-test-data.service';
import { LabTestDataModel } from '../../../models/master-data/lab-test-data.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { CurrencyNumberDirective } from '../../../directives/currency-number.directive';
import { CurrencyNumberPipe } from '../../../pipes/currency-number.pipe';
@Component({
    selector: 'modify-lab-test-data-popup',
    templateUrl: 'modify-lab-test-data-popup.component.html',
    providers: [LabTestDataService, CurrencyNumberPipe, CurrencyNumberDirective]
})

export class ModifyLabTestDataComponent implements OnInit {
    title: string;
    modifyModifyLabTestForm: FormGroup;
    medicalModifyLabTestModel = new LabTestDataModel();
    formMessage = '';
    id: any;
    public screenData = [];
    public labtestTypeData = [];

    centres = JSON.parse(localStorage.getItem(AppConstants.localStorage.centres));
    currentCentreId = localStorage.getItem(AppConstants.localStorage.centreId);
    selectAll = {centreId: '00000000-0000-0000-0000-000000000000', centreName: 'Apply to all'}
    @ViewChild('allSelected') public allSelected: MdOption;

    public isSuccess = false;
    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        private labTestService: LabTestDataService,
        public dialogRef: MdDialogRef<ModifyLabTestDataComponent>,
        public dialogService: DialogService,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.createForm();
    }

    ngOnInit() {
        this.id = this.data.id;

        this.labTestService.getScreenData().subscribe(
            result => {
                if (result) {
                    const data = result.json();
                    this.screenData = data['list'];
                }
            }
        );

        this.labTestService.getLabtestTypeData().subscribe(
            result => {
                if (result) {
                    const data = result.json();
                    this.labtestTypeData = data['list'];
                }
            }
        );

        if (this.id) {
            this.title = 'Update Lab Test';
            this.labTestService.getLabTestById(this.data.id).subscribe(
                result => {
                    if (result) {
                        const data = result.json();
                        this.medicalModifyLabTestModel = data;
                        this.modifyModifyLabTestForm.controls['labTestCategoryId'].setValue(data['labTestCategoryId']);
                        this.medicalModifyLabTestModel.centreIds = [this.currentCentreId];
                    }
                }
            );
        } else {
            this.title = 'Add New Lab Test';
            this.modifyModifyLabTestForm.controls['labTestCategoryId'].setValue(this.data.categoryId);
            this.medicalModifyLabTestModel.labTestCategoryName = this.data.categoryName;
            this.medicalModifyLabTestModel.centreIds = [this.currentCentreId];
        }

    }


    createForm() {
        this.modifyModifyLabTestForm = this.formBuilder.group({
            labTestCategoryId: '',
            labTestCategoryName: '',
            labTestName: ['', [Validators.required]],
            manufacturerID: [''],
            description: [''],
            costPrice: [''],
            screenType: [''],
            labtestType: [''],
            priority: ['', [ValidationService.isValidNumber0To999]],
            centreIds: ['', [Validators.required]],
            labTestId: ['']
        });
    }

    tosslePerOne() {
      if (this.allSelected.selected) {
        this.allSelected.deselect();
        let updatedValues = this.modifyModifyLabTestForm.controls.centreIds.value.filter(value => value !== this.selectAll.centreId);
        this.modifyModifyLabTestForm.controls.centreIds.setValue(updatedValues);
        return false;
      }
      if (this.modifyModifyLabTestForm.controls.centreIds.value.length == this.centres.length)
      {
        this.allSelected.select();
        let currentValues = this.modifyModifyLabTestForm.controls.centreIds.value;
        let updatedValues = [...currentValues, this.selectAll.centreId];
        this.modifyModifyLabTestForm.controls.centreIds.setValue(updatedValues);
      }
    }
    toggleAllSelection() {
      if (this.allSelected.selected) {
          this.modifyModifyLabTestForm.controls.centreIds.patchValue([...this.centres.map(item => item.centreId), this.selectAll.centreId]);
        } else {
            this.modifyModifyLabTestForm.controls.centreIds.patchValue([]);
        }
    }

    labtestTypeChanged() {
        if (this.modifyModifyLabTestForm.value.labtestType == 2) {
            ValidationService.attachRequired(this.modifyModifyLabTestForm.controls['manufacturerID'], []);
        } else {
            ValidationService.removeRequired(this.modifyModifyLabTestForm.controls['manufacturerID'], []);
        }
    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    onSubmit() {
        if (this.modifyModifyLabTestForm.valid) {

            // set labtest type = 1
            if (!this.modifyModifyLabTestForm.value.labtestType || this.modifyModifyLabTestForm.value.labtestType == "null") {
                this.modifyModifyLabTestForm.value.labtestType = 1;
            }

            // Edit lab test if lab test id exist, if not add lab test
            if (this.medicalModifyLabTestModel.labTestId) {
                this.labTestService.updateLabTest(this.data.id, this.modifyModifyLabTestForm.value).subscribe(
                    (result) => {
                        if (result) {
                            const data = result.json();
                            this.dialogService.openSuccessDialog({ message: data.message });
                            this.isSuccess = true;
                            this.close();
                        }
                    });
            } else {
                this.labTestService.addNewLabTest(this.modifyModifyLabTestForm.value).subscribe(
                    result => {
                        if (result) {
                            const data = result.json();
                            this.dialogService.openSuccessDialog({ message: data.message });
                            this.isSuccess = true;
                            this.close();
                        }
                    }
                );
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/lab-test-data/modify-lab-test-data-popup.component.ts